import React, { useEffect } from 'react'
import $ from 'jquery'
import {
  findObjectByTestName,
  getFeedbackByTIN,
  getFeedBackDivIdByTIN,
  getTestNameFromIframe,
  setWaitingId,
  setFeedbackId
} from '../Common'

export const Theory = ({ data, getPollingData }) => {
  return (
    <div style={{ height: '100vh', overflowY: 'auto', paddingRight: '20px' }}>
      <div style={{ marginTop: '130px', marginLeft: '20px', fontSize: '22px' }}>
        The following documents establish a theoretical basis for conversational
        testing.
      </div>{' '}
      <br></br>
      <br></br>
      <br></br>
      <ol className='sampleTests-list'>
        <li>
          <a href='./pdfs/Why Testing.pdf' target='_blank'>
            Why Testing?
          </a>
          &nbsp;&ndash;&nbsp;Why testing plays a critical role in maintaining a
          free, competitive society.
        </li>
        <li>
          <a
            href='./pdfs/Mixing Conversational Items with Multiple Choice Tests.pdf'
            target='_blank'
          >
            You Can’t Test That
          </a>
          &nbsp;&ndash;&nbsp;It isn’t just that conversational tests are better
          than multiple-choice – there are simply concepts that you can’t
          reasonably test with multiple-choice that you can indeed test with
          conversational tests.
        </li>
        <li>
          <a href='./pdfs/Benefits of Conversational Exams.pdf' target='_blank'>
            Benefits
          </a>
          &nbsp;&ndash;&nbsp;The multiple benefits of conversational testing –
          from measuring response latency to accepting alternative correct
          responses and many more.
        </li>
        <li>
          <a
            href='./pdfs/Item Efficiency for Conversational Exams.pdf'
            target='_blank'
          >
            Item Efficiency for Conversational Exams
          </a>
          &nbsp;&ndash;&nbsp;A definition of item efficiency and an illustration
          of why conversational items are more efficient than multiple choice or
          fill-in the blank.
        </li>
        <li>
          <a
            href='./pdfs/Conversational DEI Characteristics.pdf'
            target='_blank'
          >
            Elevator Speech
          </a>
          &nbsp;&ndash;&nbsp;Eleven bullet points summarizing the reasons
          conversational testing is so powerful.
        </li>
        <li>
          <a href='./pdfs/Cf Advanced Item Types.pdf' target='_blank'>
            Comparison of Advanced Item Types
          </a>
          &nbsp;&ndash;&nbsp;Many so-called ‘advanced item types’ are actually
          multiple-choice items with a different user interface. A comparison of
          these innovative item types with conversational items.
        </li>
        <li>
          <a href='./pdfs/A Short History of Testing.pdf' target='_blank'>
            Brief History
          </a>
          &nbsp;&ndash;&nbsp;How testing has evolved from tribal tests, through
          multiple-choice testing and performance testing to conversational
          tests.
        </li>
      </ol>
    </div>
  )
}
